const blankToNull = require('./../../../utils').blankToNull

export function validate(record) {
  blankToNull(record)
  return new Promise((resolve) => resolve({ record }))
}
